
import { __ } from '@wordpress/i18n';
import { useState, Fragment, useEffect, useRef } from "@wordpress/element";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Transition } from "@headlessui/react";
import { Backdrop } from "./misc";
import cx from "classnames";
import { CloseIcon } from "../icons";
import { IconButton } from "./icon-button";

export function Modal( props: {
	open?: boolean,
	setOpen?: ( val: boolean ) => void,
	button?: ( open: boolean, setOpen: ( val: boolean ) => void ) => void,
	backdrop?: boolean | "blur",
	children: any,
	defaultValue?: boolean
} ) {
	const [ overlayRef, setOverlayRef ] = useState<any>();
	const [ innerOpen, setInnerOpen ] = useState( props.defaultValue !== undefined ? props.defaultValue : false );

	const open = props.open == undefined ? innerOpen : props.open;
	const setOpen = props.setOpen == undefined ? setInnerOpen : props.setOpen;

	// scrollbar padding
	useEffect( () => {
		let elms = [];
		if ( overlayRef ) {
			const scrollBarSize = getComputedStyle( document.body ).getPropertyValue( "--removed-body-scroll-bar-size" );
			elms = document.querySelectorAll( '.swt-modal-scrollbar-padding' );
			elms.forEach( elm => {
				elm.style.paddingRight = scrollBarSize;
			} );
		}

		return () => {
			elms.forEach( elm => {
				elm.style.paddingRight = '0';
			} );
		}
	}, [ overlayRef ] );

	let css = "z-40 flex h-full pt-10 md:h-auto md:items-center md:justify-center"; // 100% hoch sm

	css = "z-40 grid justify-center items-center md:px-2";

	return (
		<>
			{ props.button && props.button( { open: open, setOpen: setOpen } ) }
			<Transition.Root appear={ true } show={ open }>
				<DialogPrimitive.Root defaultOpen={ true } open={ open } onOpenChange={ setOpen }>
					<DialogPrimitive.Portal forceMount>
						<div>
							<Backdrop blur={ props.backdrop == "blur" }>
								{ ( { className } ) => (
									<DialogPrimitive.Overlay
										ref={ setOverlayRef }
										forceMount
										className={ cx( css, className ) }
									>

										{ typeof ( props.children ) == "function"
											? props.children( { open: open, setOpen: setOpen } )
											:
											props.children
										}
									</DialogPrimitive.Overlay>
								) }
							</Backdrop>
						</div>
					</DialogPrimitive.Portal>
				</DialogPrimitive.Root>
			</Transition.Root>
		</>
	);
}

Modal.DialogClose = function ( props: { variant?: string, size?: string, className?: string } ) {
	const closeRef = useRef();
	const variant = props.variant ? props.variant : "transparent";
	const size = props.size ? props.size : "lg";

	return (
		<>
			<button aria-hidden="true"></button>
			<DialogPrimitive.Close className={ cx(
				props.className,
				"focus:outline-none no-tap-highlight",
				"focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:rounded-full focus-visible:ring-ui-primary"
			) }>
				<IconButton as="div" variant={ variant } size={ size } icon={ <CloseIcon /> }></IconButton>
			</DialogPrimitive.Close>
		</>
	)
}

Modal.Dialog = function ( props: { header?: any, children: any, className?: string } ) {
	// 100 % auf sm
	let css = "flex flex-col drop-shadow-2xl text-ui-700 bg-white rounded-t-2xl h-full md:max-h-[calc(95vh-3rem)] md:h-auto rounded-b-2xl overflow-hidden";

	css = "max-h-[calc(95vh-6rem)] max-w-screen flex flex-col drop-shadow-2xl text-ui-700 bg-white rounded-t-2xl rounded-b-2xl overflow-hidden";
	return (
		<DialogPrimitive.Content
			className={ cx( css, props.className ) }
		>
			{ /* z-10 damit beim overflow z.B. noch in den header geklickt werden kann */ }
			<div className="z-10 flex items-center p-4 gap-x-2">
				{ props.header && props.header() }
				<Modal.DialogClose className="ml-auto"></Modal.DialogClose>
			</div>

			{ typeof ( props.children ) == "function"
				? props.children( { className: "px-4 pb-4 overflow-y-scroll md:overflow-y-auto" } )
				:
				<div className={ "px-4 pb-4 overflow-y-scroll md:overflow-y-auto" }>
					{ props.children }
				</div>
			}
			<div className="p-1 bg-primary-500"></div>
		</DialogPrimitive.Content>
	)
}

Modal.Content = DialogPrimitive.Content;
